import { css } from 'linaria';

export const collectionCardsGrid = css`
  && {
    column-gap: 32px;

    @media (--only-mobile) {
      grid-template-rows: none;
    }
  }
`;

export const collectionCard = css`
  && {
    @media (--to-desktop) {
      padding: 32px;
      padding-top: 128px;
    }

    @media (--only-mobile) {
      padding-right: 24px;
      padding-left: 24px;
    }
  }
`;

export const collectionCardTitle = css`
  && {
    @media (--only-tablet) {
      margin-bottom: 12px;
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const collectionCardsDescription = css`
  && {
    width: 398px;
    font-size: 14px;
    line-height: 20px;

    @media (--only-desktop) {
      width: 278px;
    }

    @media (--to-desktop) {
      width: 100%;
    }
  }
`;

export const collectionCardIcon = css`
  && {
    @media (--to-desktop) {
      inset: 32px auto auto 32px;
      width: 80px;
      height: 80px;
    }

    @media (--only-mobile) {
      left: 24px;
    }
  }
`;

export const collectionCardsButton = css`
  && {
    @media (--only-mobile) {
      width: 100%;
    }
  }
`;
